module.exports = __webpack_public_path__ + "img/logo_dgert.4b0f4f4b.svg";